import React, { useState, useEffect, useRef, useCallback } from "react";
import { producaov2 as api } from "../../../services/apis";
import { Icon, Divider, Header } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  Grid,
  Grid2,
  GridGeral,
  GridPrincipal,
  LabelTitle,
  LabelText,
  Button,
  Principal,
  Div,
} from "./styles";
import swal from "sweetalert";
import { withRouter, Link } from "react-router-dom";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import Clima from "../../../components/Admin/Clima";
import Tempo from "../../../components/Admin/Tempo";
import { isAuthAdmin } from "../../../services/auth";
// import AlunosSelector from "../../../components/Admin/AlunosSelector";

const Home = (props) => {
  const [alunos, setAlunos] = useState("");
  const [cursos, setCursos] = useState("");
  const [artigos, setArtigos] = useState("");
  const [treinamentos, setTreinamentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const nome = JSON.parse(localStorage.getItem("USER_NODE")).nome;

  useEffect(() => {
    loadAuth();

  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/";
      return null;
    }
  };

  const loadContagemAlunos = async () => {
    await api
      .get(`admin/contagem/alunos`)
      .then(async (res) => {
        let logs = { local: "home", texto: `entrou na home` };
        await api.post("system_logs", { acao: JSON.stringify(logs) });
        setAlunos(res.data);
      })
      .catch((err) => {
        swal("Não foi possível carregar a quantidade de alunos", err, "error");
      });
  };
  const loadContagemCursos = async () => {
    await api
      .get(`/contagem/cursos_ativos`)
      .then((res) => {
        setCursos(res.data);
      })
      .catch((err) => {
        swal(
          "Não foi possível carregar a quantidade de cursos ativo",
          err,
          "error"
        );
      });
  };

  const loadContagemArtigos = async () => {
    await api
      .get(`/admin/blog/contagem/artigos`)
      .then((res) => {
        setArtigos(res.data);
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar a quantidade de artigos", err, "error");
      });
  };

  // const handleAlunoChange = (value) => {
    
  //   if(value){
  //     window.location.href =`/admin/dashboard/aluno/${value}`;

  //   }
  // };
  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          {/* <Header as="h1" style={{}}>Painel de Controle :: Grupo Voitto</Header>{/*} */}
          {/* <Header as="h2">Olá {nome}</Header> */} 
          {/* <AlunosSelector handleChange={handleAlunoChange} /> */}
          <Div>
            <Clima />
          </Div>
          <div>
            <Grid>
              <GridGeral>
                <div>
                  <LabelTitle>
                    <Icon name="users icon"></Icon>
                    {alunos}
                  </LabelTitle>
                </div>
                <div>
                  <LabelText>Usuários Ativos</LabelText>
                </div>
                <div>
                  <Button href="/admin/alunos">Ir</Button>
                </div>
              </GridGeral>
              <GridGeral>
                <div>
                  <LabelTitle>
                    <Icon name="check square icon"></Icon>
                    {cursos}
                  </LabelTitle>
                </div>
                <div>
                  <LabelText>Cursos ativo</LabelText>
                </div>
                <div>
                  <Button href="/admin/cursos">Ir</Button>
                </div>
              </GridGeral>
              <GridGeral>
                <div>
                  <LabelTitle>
                    <Icon name="newspaper icon"></Icon>
                    {artigos}
                  </LabelTitle>
                </div>
                <div>
                  <LabelText>Postagens no blog</LabelText>
                </div>
                <div>
                  <Button href="/admin/blog">Ir</Button>
                </div>
              </GridGeral>
            </Grid>
            <Grid>
              <GridGeral>
                <div>
                  <LabelTitle>
                    <Icon name="trello icon"></Icon>
                  </LabelTitle>
                </div>
                <div>
                  <LabelText>Trello</LabelText>
                </div>
                <div>
                  <Button href="https://trello.com/b/yaqjPYsU/grupo-voitto">
                    Ir
                  </Button>
                </div>
              </GridGeral>
              <GridGeral>
                <div>
                  <LabelTitle>
                    <Icon name="facebook icon"></Icon>
                  </LabelTitle>
                </div>
                <div>
                  <LabelText>Facebook</LabelText>
                </div>
                <div>
                  <Button href="https://pt-br.facebook.com/grupovoitto/">
                    Ir
                  </Button>
                </div>
              </GridGeral>
              <GridGeral>
                <div>
                  <LabelTitle>
                    <Icon name="youtube icon"></Icon>
                  </LabelTitle>
                </div>
                <div>
                  <LabelText>Youtube</LabelText>
                </div>
                <div>
                  <Button href="https://www.youtube.com/channel/UCr2UVc__HXel0LITdAO7Kvw">
                    Ir
                  </Button>
                </div>
              </GridGeral>
            </Grid>
          </div>
          <Divider hidden />
          <Header as="h3">Principais Funções</Header>
          <Grid2>
            <GridPrincipal>
              <Principal href="/admin/inscricoes">
                <Icon name="users icon" />
                Inscricões
              </Principal>
            </GridPrincipal>

            <GridPrincipal>
              <Principal href="/admin/ead/cursos">
                <Icon name="desktop icon" />
                Plataforma
              </Principal>
            </GridPrincipal>

            <GridPrincipal>
              <Principal href="/admin/notificacoes">
                <Icon name="bell icon" />
                Notificações
              </Principal>
            </GridPrincipal>
          </Grid2>
          <Grid2>
            <GridPrincipal>
              <Principal href="/admin/cupons">
                <Icon name="tag icon" />
                Cupons
              </Principal>
            </GridPrincipal>

            <GridPrincipal>
              <Principal href="/admin/relatorios">
                <Icon name="table icon" />
                Relatórios
              </Principal>
            </GridPrincipal>
          </Grid2>
          <Grid2>
            <GridPrincipal>
              <Principal href="/admin/alunos">
                <Icon name="user icon" />
                Pessoas
              </Principal>
            </GridPrincipal>
          </Grid2>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(Home);
